function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './WithoutMedia.css';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../../atoms/RouterLink';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import React from 'react';
var WithoutMedia = function WithoutMedia(_ref) {
  var description2 = _ref.description2,
    cTALink = _ref.cTALink,
    ctaLabel = _ref.ctaLabel,
    title = _ref.title,
    titleWrapperHeight = _ref.titleWrapperHeight,
    hasCta = _ref.hasCta,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("div", {
    className: 'empty-placeholder',
    style: _objectSpread(_objectSpread({
      width: '100%'
    }, titleWrapperHeight), {}, {
      marginBottom: '0.8rem'
    })
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: 'section-detail-description',
    field: description2
  })), hasCta && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "section-detail-button btn btn-secondary",
    href: cTALink.href,
    title: "".concat(ctaLabel),
    linktype: cTALink.linktype,
    linksTarget: cTALink.target,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [title.value, ctaLabel]);
    }
  }, ctaLabel))));
};
var commonStyles = "c1ocolel";
export default WithoutMedia;